export enum AttachmentType {
  CURP = "Mexico - Unique Population Registry Key",
  NSS = "Mexico - Social Security Number",
  RFC = "Mexico - Treasure Department",
  INE = "Mexico - National Electoral Institute",
}

export interface UploadDetails {
  documentType: AttachmentType;
  attachmentSubType: string;
  imageBase64?: string;
  expirationDate?: string;
  fileName: string;
  contentType: string;
  returnPresignedUrl?: boolean;
  candidateId?: string;
}

export enum AttachmentSubType {
  FRONT = "FRONT",
  BACK = "BACK",
}
